/* eslint-disable array-callback-return */
import { createSlice } from "@reduxjs/toolkit";
import { viewType } from "../utils/util";
import { getParticipiantsJidSortedData, getTrackKey, isUpdateTrack, randomString } from "../utils/functions";

export const confSlice = createSlice({
  name: "conf",
  initialState: {
    localAudioTrack: null,
    localVideoTrack: null,
    localDesktopVideoTrack: null,
    localDesktopAudioTrack: null,
    mediaPermissionPrompt: false,
    screenShared: false,
    view: viewType.gallery,
    lastView: viewType.gallery,
    maxVideos: 24,
    dominantSpeaker: null,
    numPages: 1,
    currrentPage: 1,
    screenSharedJid: null,
    prevScreenSharedJid: null,
    ///
    localUser: {},
    roomDetail: {},
    guestDetail: {},
    ///
    localParticipantData: null,
    remoteParticipantIds: [],
    room: undefined,
    ///
    participantsJID: [],
    participantsList: [],
    participantsUnmuted: [],
    participantsGuest: [],
    participantsHost: [],
    participantsWaiting: [],
    participantsScreenShared: [],
    participantIds: [],
    unmutedParticipantIds: [],
    activeVideoParticipantIds: [],
    mediaShareparticipantsJID: null,
    ///
    localParticipantDetail: {},
    gallery_participants: "",
    dominant: "",
    selectLanguage: "en",
    isBackButtonShow: false,
    clickForgotPassword: false,
    chatMessage: [],
    featuredMsg: {},
    currentRoom: "",
    muteAllLoader: false,
    unmuteAllLoader: false,
    myRole: "",
    openLoginModel: false,
    orientation: "PORTRAIT",
    chatClick: false,
    attendeesClick: false,
    guestsUnmuteLoader: false,
    recordingViewValue: "active",
    extensionList: [],
    isRequestDeclined: false,
    mutedAttendeesLoader: false,
    waitingStatusLoader: false,
    breakoutRoomJoined: false,
    openRecordingModal: false,
    mic: false,
    camera: false,
    speaker: true,
    raise: false,
    waitingRoomLoaders: {
      accept: [],
      decline: [],
    },
    waitingRoomPopup: false,
    waitingEnabled: false,
    exitModal: false,
    feedbackPopUp: false,
    participantsLoaders: {
      audio: [],
      video: [],
      hand_raised: [],
    },
    conferenceConnecting: false,
    muteUnmutePermission: false,
    openStreamManageModal: false,
    mouseOverUser: "",
    openUpgradePlanModal: false,
    waitingRoomModal: false,
    hostRequiredModal: false,
    videoPlayModal: false,
    unreadMessageCount: 0,
    showMenu: false,
    showMenuType: "",
    showRecording: false,
    showStreaming: false,
    shareScreen: false,
    openStopRecordingModal: false,
    isRecordingStart: false,
    recordingDuration: 0,
    recordingStopLoader: false,
    recordingStartLoader: false,
    streamingStarted: false,
    startStreamingLoader: false,
    stopStreamingLoader: false,
    addDestinationType: "custom",
    ratingPopUp: false,
    socketConnected: false,
    recordingData: {},
    recordingName: "",
    streamingTitleDescription: {
      title: "",
      description: "",
      display_social_media_chat: "",
    },
    streamingDestinations: [],
    timeCal: 0,
    intval: null,
    hours: 0,
    minutes: 0,
    seconds: 0,
    streamingData: {},
    streamingDuration: 0,
    destinationsList: [],
    streamingErrors: {},
    destinationListLoader: false,
    maxDestination: false,
    withoutChoosingDestination: false,
    streamTimeCal: 0,
    streamIntval: null,
    streamHours: 0,
    streamMinutes: 0,
    streamSeconds: 0,
    waitingRoomCycle: false,
    waitingRoomTitle: "",
    screenDimension: {},
    windowDimension: {},
    page: "JoinFlow",
    previousRouteStep: "",
    loginAsGuest: false,
    audioInputList: [],
    videoInputList: [],
    audioOutputList: [],
    cameraDevice: null,
    micDevice: null,
    speakerDevice: null,
    tracks: [],
    participants: {},
    hasAudioPermission: false,
    hasVideoPermission: false,
    hasAudioEnable: false,
    hasVideoEnable: false,
    joinWithVideo: false,
    loaderEffect: false,
    waitingTitleInterval: null,
    showInviteModal: false,
    showAvSettingModal: false,
    showEditProfileModal: false,
    showPhoneCommandModal: false,
    showWebinarSettingModal: false,
    showRoomSettingModal: false,
    showMeetingModal: false,
    showRoomPermissionModal: false,
    showShareWidgetModal: false,
    showManageRoomModal: false,
    showInvoiceModal: false,
    showBillingInfoModal: false,

    extensionShow: false,
    extensionDetails: {},
    mediaControls: {},
    galleryViewParticipants: [],
    trackStreamStatus: {},
    activeParticipant: {},
    presentationParticipant: {},
    currentActiveVideoTracks: {},
    participantsTracks: {},
    recentActiveSpeaker: [],
    recentUnmutedUsers: [],
    videoContainerSettings: {},
    audienceParticipants: [],

    timerExtensionShow: false,
    timerExtensionDetails: {},
    activeTimerWidget: {},
    lastActiveWidget: {},
    attendeesFrameRate :{},
    playYoutubeDetails:[],
  },

  reducers: {
    setCurrentPage: (state, action) => {
      state.currrentPage = action.payload;
    },
    setNumPages: (state, action) => {
      state.numPages = action.payload;
    },
    setDominantSpeaker: (state, action) => {
      state.dominantSpeaker = action.payload;
    },
    ///
    setSocketConnected: (state, action) => {
      state.socketConnected = action.payload;
    },
    setParticipantsList: (state, action) => {
      let tmpParticipantsList = {};
      let tmpParticipantsJID = {};
      let tmpParticipantsUnmuted = {};
      let tmpParticipantsGuest = {};
      let tmpParticipantsHost = {};
      let tmpParticipantsWaiting = {};
      let tmpParticipantsHandRaised = {};
      let tmpparticipantsScreenShared = {};
      let screenSharedJid = state.screenSharedJid;
      let interactiveParticipants = {};
      let participantIds = [];
      let _unmutedParticipantIds = [];
      let _activeVideoParticipantIds = [];

      let prevInteractiveParticipantsIds = Object.keys(state.participantsJID);

      if (Array.isArray(action.payload) && action.payload.length > 0) {
        action.payload.forEach(val => {
          if (!val?.is_hidden) {
            if (val.token_unique === state.localUser.token_unique) {
              state.localUser = val;
            } else {
              if (
                val.waiting_status === 'accepted' &&
                val.interaction_type === 'interactive' &&
                val.jid
              ) {
                tmpParticipantsJID[val.jid] = val;
                participantIds.push(val.jid);
                if (val.audio === true) {
                  _unmutedParticipantIds.push(val.jid);
                }

                if (val.video === true) {
                  _activeVideoParticipantIds.push(val.jid);
                }
              }
              tmpParticipantsList[val.token_unique] = val;

              if (
                val.role !== 'guest' &&
                val.waiting_status === 'accepted' &&
                val.jid
              ) {
                tmpParticipantsHost[val.token_unique] = val;
              }

              if (
                (val.role === 'guest') &&
                val.waiting_status === 'accepted'
              ) {
                if (val.role === 'guest' && val.jid) {
                  tmpParticipantsGuest[val.token_unique] = val;
                }

                if (tmpParticipantsWaiting[val.token_unique]) {
                  delete tmpParticipantsWaiting[val.token_unique];
                }
              } else if (
                (val.role === 'guest') &&
                val.waiting_status === 'pending'
              ) {
                tmpParticipantsWaiting[val.token_unique] = val;
              }

              if (val.hand_raised) {
                tmpParticipantsHandRaised[val.token_unique] = val;
              } else if (tmpParticipantsHandRaised[val.token_unique]) {
                delete tmpParticipantsHandRaised[val.token_unique];
              }

              if (val.audio && val.waiting_status === 'accepted') {
                tmpParticipantsUnmuted[val.jid] = val;
              } else if (tmpParticipantsUnmuted[val.jid]) {
                delete tmpParticipantsUnmuted[val.jid];
              }

              ///Presentation view code
              if (val.waiting_status === 'accepted' && val?.screenShare) {
                tmpparticipantsScreenShared[val.jid] = val.jid;
                screenSharedJid = val.jid;
              }

              ////////
            }
          }
        });
      }
      // active speaker

      if (prevInteractiveParticipantsIds.length > 0) {
        prevInteractiveParticipantsIds.forEach(id => {
          if (tmpParticipantsJID[id]) {
            interactiveParticipants[id] = tmpParticipantsJID[id];
          }
        });
        if (
          Object.keys(tmpParticipantsJID).length >
          prevInteractiveParticipantsIds.length ||
          Object.keys(tmpParticipantsJID).length ===
          prevInteractiveParticipantsIds.length
        ) {
          var uniqueArray = Object.keys(tmpParticipantsJID).filter(function (
            o1,
          ) {
            return !prevInteractiveParticipantsIds.some(function (o2) {
              return o1 === o2;
            });
          });
          uniqueArray.forEach(id => {
            if (tmpParticipantsJID[id]) {
              interactiveParticipants[id] = tmpParticipantsJID[id];
            }
          });
        }
      } else {
        const sortedList = getParticipiantsJidSortedData(
          Object.values(tmpParticipantsJID),
        );
        let UpdatedParticipantsJID = {};

        sortedList.forEach(item => {
          UpdatedParticipantsJID[item.jid] = item;
        });

        interactiveParticipants = { ...UpdatedParticipantsJID };
      }

      state.participantsJID = interactiveParticipants;

      // state.participantsJID = tmpParticipantsJID;
      state.participantsList = tmpParticipantsList;
      state.participantsUnmuted = tmpParticipantsUnmuted;
      state.participantsGuest = tmpParticipantsGuest;
      state.participantsHost = tmpParticipantsHost;
      state.participantsWaiting = tmpParticipantsWaiting;
      state.participantsHandRaised = tmpParticipantsHandRaised;
      state.participantIds = participantIds;
      state.unmutedParticipantIds = _unmutedParticipantIds;
      state.activeVideoParticipantIds = _activeVideoParticipantIds;

      if (!state.mediaShareVideoTrack) {
        state.screenSharedJid = screenSharedJid;
      }
      if (!state.participantsScreenShared[screenSharedJid]) {
        if (screenSharedJid) {
          state.view = viewType.presentation;
        }
      }

      if (
        Object.keys(tmpparticipantsScreenShared).length === 0 &&
        !state.mediaShareparticipantsJID
      ) {
        if (state.view === viewType.presentation) {
          state.view = state.lastView;
        }
      }
      state.participantsScreenShared = tmpparticipantsScreenShared;
      state.forceUpdate = null;
    },
    updParticipantsList: (state, action) => {
      let tmpParticipantsJID = { ...state.participantsJID };
      let tmpParticipantsList = { ...state.participantsList };
      let tmpParticipantsUnmuted = { ...state.participantsUnmuted };
      let tmpParticipantsGuest = { ...state.participantsGuest };
      let tmpParticipantsHost = { ...state.participantsHost };
      let tmpParticipantsWaiting = { ...state.participantsWaiting };
      let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
      let tmpParticipantsHandRaised = { ...state.participantsHandRaised };
      // let tmpRecentUnmutedUser = [...state.recentUnmutedUsers];
      let tmpParticipantIds = [...(state.participantIds || [])];
      let _unmutedParticipantIds = [...(state.unmutedParticipantIds || [])];
      let _activeVideoParticipantIds = [...(state.activeVideoParticipantIds || [])];

      let val = action.payload;
      const participantIndex = tmpParticipantIds.findIndex(
        item => item === val.jid,
      );

      if (!val?.is_hidden) {
        if (val.token_unique === state.localUser.token_unique) {
          state.localUser = val;
        } else {
          const userScreenShared = val?.screenShare && !val?.blocked ? true : false;
          let preScreenSharedValue = tmpParticipantsJID[val.jid]?.screenShare && !tmpParticipantsJID[val.jid]?.blocked ? true : false;
          let previousName = tmpParticipantsJID[val.jid]?.name;
          let previousProfileImage = tmpParticipantsJID[val.jid]?.profile_image;
          let prevOrientation = tmpParticipantsJID[val.jid]?.orientation;
          let prevBlockStatus = tmpParticipantsJID[val.jid]?.blocked;
          let prevKeepMuted = tmpParticipantsJID[val.jid]?.keep_muted;
          let prevAttendeeRecording = tmpParticipantsJID[val.jid]?.attendee_recording;
          let prevMirrorView = tmpParticipantsJID[val.jid]?.mirror_view;

          if (
            val.waiting_status === 'accepted' &&
            val.interaction_type === 'interactive' &&
            val.jid
          ) {
            tmpParticipantsJID[val.jid] = val;
            if (participantIndex === -1) {
              tmpParticipantIds.push(val.jid);
              state.participantIds = tmpParticipantIds;
            }
            if (val.audio === true) {
              if (!_unmutedParticipantIds.includes(val.jid)) {
                _unmutedParticipantIds.push(val.jid);
                state.unmutedParticipantIds = _unmutedParticipantIds;
              }
            } else if (_unmutedParticipantIds.includes(val.jid)) {
              _unmutedParticipantIds = _unmutedParticipantIds.filter(
                item => item !== val.jid,
              );
              state.unmutedParticipantIds = _unmutedParticipantIds;
            }

            if (val.video === true) {
              if (!_activeVideoParticipantIds.includes(val.jid)) {
                _activeVideoParticipantIds.push(val.jid);
                state.activeVideoParticipantIds = _activeVideoParticipantIds;
              }
            } else if (_activeVideoParticipantIds.includes(val.jid)) {
              _activeVideoParticipantIds = _activeVideoParticipantIds.filter(
                item => item !== val.jid,
              );
              state.activeVideoParticipantIds = _activeVideoParticipantIds;
            }

            if (
              val?.name !== previousName ||
              val?.profile_image !== previousProfileImage ||
              val?.orientation !== prevOrientation ||
              val?.blocked !== prevBlockStatus ||
              val?.keep_muted !== prevKeepMuted ||
              val?.attendee_recording !== prevAttendeeRecording ||
              val?.mirror_view !== prevMirrorView
            ) {
              state.refreshVideoView = randomString(10);
            }
          }

          if (val.interaction_type === 'streaming') {
            if (tmpParticipantsList[val.token_unique]) {
              delete tmpParticipantsList[val.token_unique];
            }
          } else {
            tmpParticipantsList[val.token_unique] = val;
          }

          if (
            val.role !== 'guest' &&
            val.waiting_status === 'accepted' &&
            val.jid
          ) {
            tmpParticipantsHost[val.token_unique] = val;
            if (tmpParticipantsGuest[val.token_unique]) {
              delete tmpParticipantsGuest[val.token_unique];
            }
          }

          if (
            (val.role === 'guest') &&
            val.waiting_status === 'accepted'
          ) {
            if (val.role === 'guest' && val.jid) {
              tmpParticipantsGuest[val.token_unique] = val;

              if (tmpParticipantsHost[val.token_unique]) {
                delete tmpParticipantsHost[val.token_unique];
              }
            }

            if (tmpParticipantsWaiting[val.token_unique]) {
              delete tmpParticipantsWaiting[val.token_unique];
            }
          } else if (
            (val.role === 'guest') &&
            val.waiting_status === 'declined'
          ) {
            if (tmpParticipantsWaiting[val.token_unique]) {
              delete tmpParticipantsWaiting[val.token_unique];
            }
          } else if (
            (val.role === 'guest') &&
            val.waiting_status === 'pending'
          ) {
            tmpParticipantsWaiting[val.token_unique] = val;
          }

          if (val.hand_raised) {
            tmpParticipantsHandRaised[val.token_unique] = val;
          } else if (tmpParticipantsHandRaised[val.token_unique]) {
            delete tmpParticipantsHandRaised[val.token_unique];
          }

          if (val.audio && val.waiting_status === 'accepted') {
            tmpParticipantsUnmuted[val.jid] = val;
          } else if (tmpParticipantsUnmuted[val.jid]) {
            delete tmpParticipantsUnmuted[val.jid];
          }

          ///Presentation view code

          let screenSharedJid = state.screenSharedJid;
          const prevScreenSharedJid = [];
          if (
            val.waiting_status === 'accepted' &&
            userScreenShared &&
            preScreenSharedValue !== true
          ) {
            tmpparticipantsScreenShared[val.jid] = val.jid;
            screenSharedJid = val.jid;
          } else if (
            val.waiting_status === 'accepted' &&
            !userScreenShared &&
            preScreenSharedValue === true
          ) {
            if (tmpparticipantsScreenShared[val.jid]) {
              delete tmpparticipantsScreenShared[val.jid];
            }

            if (screenSharedJid === val.jid) {
              Object.keys(tmpparticipantsScreenShared).forEach(key =>
                prevScreenSharedJid.push(key),
              );
              if (prevScreenSharedJid.length > 0) {
                screenSharedJid =
                  prevScreenSharedJid[prevScreenSharedJid.length - 1];
              } else {
                screenSharedJid = null;
              }
            }
          }

          if (screenSharedJid === val.jid && preScreenSharedValue === false) {
            state.view = viewType.presentation;
          } else if (!screenSharedJid && preScreenSharedValue === true) {
            state.view = state.lastView;
          }
          if (!state.mediaShareVideoTrack) {
            state.screenSharedJid = screenSharedJid;
          }
          state.participantsScreenShared = tmpparticipantsScreenShared;

          ///////////////
        }

        state.participantsJID = tmpParticipantsJID;
        state.participantsList = tmpParticipantsList;
        state.participantsUnmuted = tmpParticipantsUnmuted;
        state.participantsGuest = tmpParticipantsGuest;
        state.participantsHost = tmpParticipantsHost;
        state.participantsWaiting = tmpParticipantsWaiting;
        state.participantsHandRaised = tmpParticipantsHandRaised;
        // state.recentUnmutedUsers = tmpRecentUnmutedUser;
        // state.participantIds = tmpParticipantIds;

        state.forceUpdate = val;
      }
    },
    remParticipantsList: (state, action) => {
      let tmpParticipantsJID = { ...state.participantsJID };
      let tmpParticipantsList = { ...state.participantsList };
      let tmpParticipantsUnmuted = { ...state.participantsUnmuted };
      let tmpParticipantsGuest = { ...state.participantsGuest };
      let tmpParticipantsHost = { ...state.participantsHost };
      let tmpParticipantsWaiting = { ...state.participantsWaiting };
      let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
      let tmpParticipantsHandRaised = { ...state.participantsHandRaised };
      // let tmpRecentUnmutedUser = [...state.recentUnmutedUsers];
      let tmpParticipantIds = [...(state.participantIds || [])];
      let _unmutedParticipantIds = [...(state.unmutedParticipantIds || [])];
      let _activeVideoParticipantIds = [...(state.activeVideoParticipantIds || [])];

      let val = action.payload;

      const updatedParticipantIds = tmpParticipantIds.filter(
        item => item !== val.jid,
      );

      delete tmpParticipantsJID[val.jid];

      delete tmpParticipantsList[val.token_unique];
      delete tmpParticipantsUnmuted[val.jid];
      delete tmpParticipantsGuest[val.token_unique];
      delete tmpParticipantsHost[val.token_unique];

      if (_unmutedParticipantIds.includes(val.jid)) {
        _unmutedParticipantIds = _unmutedParticipantIds.filter(
          item => item !== val.jid,
        );
        state.unmutedParticipantIds = _unmutedParticipantIds;
      }
      if (_activeVideoParticipantIds.includes(val.jid)) {
        _activeVideoParticipantIds = _activeVideoParticipantIds.filter(
          item => item !== val.jid,
        );
        state.activeVideoParticipantIds = _activeVideoParticipantIds;
      }

      if (tmpParticipantsWaiting[val.token_unique]) {
        delete tmpParticipantsWaiting[val.token_unique];
      }

      if (tmpParticipantsHandRaised[val.token_unique]) {
        delete tmpParticipantsHandRaised[val.token_unique];
      }
      ///Presentation view code
      let screenSharedJid = state.screenSharedJid;
      const prevScreenSharedJid = [];
      if (tmpparticipantsScreenShared[val.jid]) {
        delete tmpparticipantsScreenShared[val.jid];
      }

      if (screenSharedJid === val.jid) {
        Object.keys(tmpparticipantsScreenShared).forEach(key =>
          prevScreenSharedJid.push(key),
        );
        if (prevScreenSharedJid.length > 0) {
          screenSharedJid = prevScreenSharedJid[prevScreenSharedJid.length - 1];
        } else {
          screenSharedJid = null;
        }
      }
      if (!state.mediaShareVideoTrack) {
        state.screenSharedJid = screenSharedJid;
      }
      state.participantsScreenShared = tmpparticipantsScreenShared;

      if (!screenSharedJid) {
        state.view = state.lastView;
      }
      ///////////////

      state.participantsJID = tmpParticipantsJID;
      state.participantsList = tmpParticipantsList;
      state.participantsUnmuted = tmpParticipantsUnmuted;
      state.participantsGuest = tmpParticipantsGuest;
      state.participantsHost = tmpParticipantsHost;
      state.participantsWaiting = tmpParticipantsWaiting;
      state.participantsHandRaised = tmpParticipantsHandRaised;
      state.forceUpdate = val;
      state.participantIds = updatedParticipantIds;

      // state.recentUnmutedUsers = tmpRecentUnmutedUser;
    },
    setMediaShareParticipants: (state, action) => {
      const jid = action.payload;

      state.mediaShareparticipantsJID = jid;
      // let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
      // tmpparticipantsScreenShared[jid] = jid;
      // state.screenSharedJid = jid;
      // state.participantsScreenShared = tmpparticipantsScreenShared;

      // state.view = viewType.presentation;
    },
    remMediaShareParticipants: (state, action) => {
      const jid = action.payload;
      state.mediaShareparticipantsJID = null;

      let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
      let screenSharedJid = state.screenSharedJid;
      const prevScreenSharedJid = [];
      if (tmpparticipantsScreenShared[jid]) {
        delete tmpparticipantsScreenShared[jid];
      }

      if (screenSharedJid === jid) {
        Object.keys(tmpparticipantsScreenShared).forEach(key =>
          prevScreenSharedJid.push(key),
        );
        if (prevScreenSharedJid.length > 0) {
          screenSharedJid = prevScreenSharedJid[0];
        } else {
          screenSharedJid = null;
        }
      }

      state.screenSharedJid = screenSharedJid;
      state.participantsScreenShared = tmpparticipantsScreenShared;

      if (!screenSharedJid) {
        state.view = state.lastView;
      }
    },
    ////////////////////////////////////////////
    setRoomDetails: (state, action) => {
      state.roomDetail = action.payload;
    },
    setUserDetail: (state, action) => {
      state.localUser = action.payload;
    },
    setView: (state, action) => {
      state.view = action.payload;
      if (action.payload !== viewType.presentation) {
        state.lastView = state.view;
      }
    },
    setLastView: (state, action) => {
      state.lastView = action.payload;
    },
    galleryViewParticipants: (state, action) => {
      state.gallery_participants = action.payload;
    },

    setScreenDimension: (state, action) => {
      state.screenDimension = action.payload;
    },
    setWindowDimension: (state, action) => {
      state.windowDimension = action.payload;
    },

    trackAdd: (state, action) => {
      let track = action.payload;

      let isReceivingData = true;
      let noDataFromSourceNotificationInfo;
      let galleryViewParticipants = [...state.galleryViewParticipants];
      let audienceParticipants = [...state.audienceParticipants];
      let presentationEndpoint = state?.presentationParticipant?.jid;
      let _participantsTracks = { ...state.participantsTracks };
      let _currentActiveVideoTracks = { ...state.currentActiveVideoTracks };
      let trackdata = {
        trackID: track.getId(),
        isReceivingData,
        mediaType: track.videoType,
        muted: track.isMuted(),
        noDataFromSourceNotificationInfo,
        participantId: track.getParticipantId(),
        videoStarted: false,
        type: track.type,
        jitsiTrack: track,
        volume: 1,
      };

      let trackType =
        track.type === 'video' && track.videoType === 'desktop'
          ? track.videoType
          : track.type;

      let trackKey = getTrackKey(track.getParticipantId(), trackType);

      const isTrackAdd = isUpdateTrack(
        trackType,
        trackKey,
        track,
        _participantsTracks,
      );

      if (isTrackAdd) {
        if (
          track.getParticipantId() === state.mediaShareparticipantsJID &&
          track.type === 'video' &&
          track.videoType === 'camera' &&
          !track.isMuted()
        ) {
          state.mediaShareVideoTrack = true;
          state.screenSharedJid = state.mediaShareparticipantsJID;
          state.view = viewType.presentation;
        }

        // state.tracks.push(trackdata);
        _participantsTracks[trackKey] = trackdata;
        state.participantsTracks = _participantsTracks;

        if (track.type === 'video') {
          if (state.view === viewType.gallery) {
            let checkOnActive = galleryViewParticipants.some(
              u => u.jid === track.getParticipantId(),
            );

            if (checkOnActive) {
              _currentActiveVideoTracks[trackKey] = trackdata;
              state.currentActiveVideoTracks = _currentActiveVideoTracks;
            }
          } else if (state.view === viewType.audience) {
            let checkOnActive = audienceParticipants.some(
              u => u.jid === track.getParticipantId(),
            );

            if (checkOnActive) {
              _currentActiveVideoTracks[trackKey] = trackdata;
              state.currentActiveVideoTracks = _currentActiveVideoTracks;
            }
          } else if (
            state.view === viewType.active ||
            state.view === viewType.activeExcludingYourself
          ) {
            if (state.activeParticipant?.jid === track.getParticipantId()) {
              // state.currentActiveVideoTracks[trackKey] = trackdata;
              _currentActiveVideoTracks[trackKey] = trackdata;
              state.currentActiveVideoTracks = _currentActiveVideoTracks;
            }
          } else if (state.view === viewType.presentation) {
            if (presentationEndpoint === track.getParticipantId()) {
              _currentActiveVideoTracks[trackKey] = trackdata;
              state.currentActiveVideoTracks = _currentActiveVideoTracks;
              state.refreshVideoView = randomString(10);
            }
          }
        }
      }
    },
    trackRemove: (state, action) => {
      let track = action.payload;
      let _participantsTracks = { ...state.participantsTracks };
      let _currentActiveVideoTracks = { ...state.currentActiveVideoTracks };

      if (
        track.getParticipantId() === state.mediaShareparticipantsJID &&
        track.type === 'video' &&
        track.videoType === 'camera'
      ) {
        state.mediaShareVideoTrack = false;
        let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
        const prevScreenSharedJid = [];
        Object.keys(tmpparticipantsScreenShared).forEach(key =>
          prevScreenSharedJid.push(key),
        );
        if (prevScreenSharedJid.length > 0) {
          state.screenSharedJid =
            prevScreenSharedJid[prevScreenSharedJid.length - 1];
        } else {
          state.screenSharedJid = null;
        }

        if (!state.screenSharedJid) {
          state.view = state.lastView;
        }
      }

      let trackType =
        track.type === 'video' && track.videoType === 'desktop'
          ? track.videoType
          : track.type;
      let trackKey = getTrackKey(track.getParticipantId(), trackType);

      if (trackKey in _participantsTracks) {
        delete _participantsTracks[trackKey];
      }

      state.participantsTracks = _participantsTracks;

      if (trackKey in _currentActiveVideoTracks) {
        delete _currentActiveVideoTracks[trackKey];
        state.currentActiveVideoTracks = _currentActiveVideoTracks;
      }
    },
    trackMediaTypeUpdate: (state, action) => {
      let track = action.payload;

      let isReceivingData = true;
      let noDataFromSourceNotificationInfo;
      let _participantsTracks = { ...state.participantsTracks };
      let _currentActiveVideoTracks = { ...state.currentActiveVideoTracks };
      let trackType =
        track.type === 'video' && track.videoType === 'desktop'
          ? track.videoType
          : track.type;

      let trackKey = getTrackKey(track.getParticipantId(), trackType);

      const isTrackUpdate = isUpdateTrack(
        trackType,
        trackKey,
        track,
        _participantsTracks,
      );

      if (isTrackUpdate) {
        if (_participantsTracks[trackKey]) {
          _participantsTracks[trackKey].mediaType = track.videoType;
          state.participantsTracks = _participantsTracks;
          if (trackKey in _currentActiveVideoTracks) {
            _currentActiveVideoTracks[trackKey].mediaType = track.videoType;
            state.currentActiveVideoTracks = _currentActiveVideoTracks;
          }
        } else {
          let galleryViewParticipants = [...state.galleryViewParticipants];
          let presentationEndpoint = state?.presentationParticipant?.jid;
          let audienceParticipants = [...state.audienceParticipants];
          let trackdata = {
            trackID: track.getId(),
            isReceivingData,
            mediaType: track.videoType,
            muted: track.isMuted(),
            noDataFromSourceNotificationInfo,
            participantId: track.getParticipantId(),
            videoStarted: false,
            type: track.type,
            jitsiTrack: track,
            volume: 1,
          };
          if (
            track.getParticipantId() === state.mediaShareparticipantsJID &&
            track.type === 'video' &&
            track.videoType === 'camera' &&
            !track.isMuted()
          ) {
            state.mediaShareVideoTrack = true;
            state.screenSharedJid = state.mediaShareparticipantsJID;
            state.view = viewType.presentation;
          }

          // state.tracks.push(trackdata);
          _participantsTracks[trackKey] = trackdata;
          state.participantsTracks = _participantsTracks;

          if (track.type === 'video') {
            if (state.view === viewType.gallery) {
              let checkOnActive = galleryViewParticipants.some(
                u => u.jid === track.getParticipantId(),
              );

              if (checkOnActive) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            } else if (state.view === viewType.audience) {
              let checkOnActive = audienceParticipants.some(
                u => u.jid === track.getParticipantId(),
              );

              if (checkOnActive) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            } else if (
              state.view === viewType.active ||
              state.view === viewType.activeExcludingYourself
            ) {
              if (state.activeParticipant?.jid === track.getParticipantId()) {
                // state.currentActiveVideoTracks[trackKey] = trackdata;
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            } else if (state.view === viewType.presentation) {
              if (presentationEndpoint === track.getParticipantId()) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            }
          }
        }
      }
      // console.log('_participantsTracks[trackKey]', _participantsTracks, state.participantsTracks, trackKey, track.videoType);
    },
    trackMuteUpdate: (state, action) => {
      let track = action.payload;

      let _participantsTracks = { ...state.participantsTracks };
      let _currentActiveVideoTracks = { ...state.currentActiveVideoTracks };
      let presentationEndpoint = state.platform === 'native' && state?.presentationParticipant?.length > 0 ? state?.presentationParticipant[0]?.jid : state?.presentationParticipant?.jid;
      let trackType =
        track.type === 'video' && track.videoType === 'desktop'
          ? track.videoType
          : track.type;
      let trackKey = getTrackKey(track.getParticipantId(), trackType);
      let isReceivingData = true;
      let noDataFromSourceNotificationInfo;
      let galleryViewParticipants = [...state.galleryViewParticipants];
      let audienceParticipants = [...state.audienceParticipants];

      let trackdata = {
        trackID: track.getId(),
        isReceivingData,
        mediaType: track.videoType,
        muted: track.isMuted(),
        noDataFromSourceNotificationInfo,
        participantId: track.getParticipantId(),
        videoStarted: false,
        type: track.type,
        jitsiTrack: track,
        volume: 1,
      };
      const isTrackUpdate = isUpdateTrack(
        trackType,
        trackKey,
        track,
        _participantsTracks,
      );

      if (isTrackUpdate) {
        if (
          track.getParticipantId() === state.mediaShareparticipantsJID &&
          track.type === 'video' &&
          track.isMuted()
        ) {
          state.mediaShareVideoTrack = false;
          let tmpparticipantsScreenShared = { ...state.participantsScreenShared };
          const prevScreenSharedJid = [];
          Object.keys(tmpparticipantsScreenShared).forEach(key =>
            prevScreenSharedJid.push(key),
          );
          if (prevScreenSharedJid.length > 0) {
            state.screenSharedJid =
              prevScreenSharedJid[prevScreenSharedJid.length - 1];
          } else {
            state.screenSharedJid = null;
          }

          if (!state.screenSharedJid) {
            state.view = state.lastView;
          }
        } else if (
          track.getParticipantId() === state.mediaShareparticipantsJID &&
          track.type === 'video' &&
          !track.isMuted()
        ) {
          state.mediaShareVideoTrack = true;
          state.screenSharedJid = state.mediaShareparticipantsJID;
          state.view = viewType.presentation;
        }

        if (_participantsTracks[trackKey]) {
          _participantsTracks[trackKey].muted = track.isMuted();
          state.participantsTracks = _participantsTracks;
        }

        if (trackKey in _currentActiveVideoTracks) {
          _currentActiveVideoTracks[trackKey].muted = track.isMuted();
          state.currentActiveVideoTracks = _currentActiveVideoTracks;
          state.refreshVideoView = randomString(10);
        } else {

          if (track.type === 'video') {
            if (state.view === viewType.gallery) {
              let checkOnActive = galleryViewParticipants.some(
                u => u.jid === track.getParticipantId(),
              );

              if (checkOnActive) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            } else if (state.view === viewType.audience) {
              let checkOnActive = audienceParticipants.some(
                u => u.jid === track.getParticipantId(),
              );
              if (checkOnActive) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
              }
            } else if (
              state.view === viewType.active ||
              state.view === viewType.activeExcludingYourself
            ) {
              if (state.activeParticipant?.jid === track.getParticipantId()) {
                // state.currentActiveVideoTracks[trackKey] = trackdata;
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
                state.refreshVideoView = randomString(10);
              }
            } else if (state.view === viewType.presentation) {
              console.log('_currentActiveVideoTracks presentationEndpoint', presentationEndpoint, track.getParticipantId())
              if (presentationEndpoint === track.getParticipantId()) {
                _currentActiveVideoTracks[trackKey] = trackdata;
                state.currentActiveVideoTracks = _currentActiveVideoTracks;
                state.refreshVideoView = randomString(10);
              }
            }
          }
        }
      }
    },

    setExtensionShow: (state, action) => {
      state.extensionShow = action.payload;
    },

    setExtensionDetails: (state, action) => {
      state.extensionDetails = action.payload;
    },
    setFeatureMsg: (state, action) => {
      state.featuredMsg = action.payload;
    },
    setMediaControls: (state, action) => {
      state.mediaControls = action.payload;
    },
    trackVolumeUpdate: (state, action) => {
      let participant = action.payload;
      let mediaIndex = state.tracks?.findIndex?.((track) => track.participantId === participant.participantId && track.type === 'audio');

      if (mediaIndex !== -1) {
        state.tracks[mediaIndex].volume = participant.volume;
      }
    },
    setParticipantsJIDList: (state, action) => {
      const list = action.payload;
      state.participantsJID = list;
    },
    setGalleryViewParticipants: (state, action) => {
      state.galleryViewParticipants = action.payload;
    },
    setAudienceParticipants: (state, action) => {
      state.audienceParticipants = action.payload;
    },
    setTrackStreamStatus: (state, action) => {
      state.trackStreamStatus = { ...state.trackStreamStatus, ...action.payload };
    },
    setActiveParticipant: (state, action) => {
      state.activeParticipant = action.payload;
    },
    setPresentationParticipant: (state, action) => {
      state.presentationParticipant = action.payload;
    },
    setCurrentActiveVideoTracks: (state, action) => {
      state.currentActiveVideoTracks = action.payload;
    },
    setVideoContainerSettings: (state, action) => {
      state.videoContainerSettings = action.payload;
    },
    setRecentActiveSpeaker: (state, action) => {
      state.recentActiveSpeaker = action.payload;
    },
    setRecentUnmutedUsers: (state, action) => {
      state.recentUnmutedUsers = action.payload;
    },
    setTimerExtensionShow: (state, action) => {
      state.timerExtensionShow = action.payload;
    },
    setTimerExtensionDetails: (state, action) => {
      state.timerExtensionDetails = action.payload;
    },
    setActiveTimerWidget: (state, action) => {
      state.activeTimerWidget = action.payload;
    },
    setLastActiveWidget: (state, action) => {
      state.lastActiveWidget = action.payload;
    },
    setAttendeesFrameRate: (state, action) => {
      state.attendeesFrameRate = action.payload;
    },
    setPlayYoutubeDetails: (state , action) => {
      state.playYoutubeDetails = action.payload;
    },
  },
});

export const {
  setCurrentPage,
  setNumPages,
  setDominantSpeaker,
  setSocketConnected,
  setParticipantsList,
  updParticipantsList,
  remParticipantsList,
  setRoomDetails,
  setUserDetail,
  setView,
  galleryViewParticipants,
  setScreenDimension,
  setWindowDimension,
  trackAdd,
  trackRemove,
  trackMediaTypeUpdate,
  trackMuteUpdate,
  setExtensionShow,
  setExtensionDetails,
  setFeatureMsg,
  remMediaShareParticipants,
  setMediaShareParticipants,
  setMediaControls,
  trackVolumeUpdate,
  setParticipantsJIDList,
  setGalleryViewParticipants,
  setAudienceParticipants,
  setTrackStreamStatus,
  setActiveParticipant,
  setCurrentActiveVideoTracks,
  setPresentationParticipant,
  setVideoContainerSettings,
  setRecentActiveSpeaker,
  setRecentUnmutedUsers,
  setLastView,
  setTimerExtensionShow,
  setTimerExtensionDetails,
  setActiveTimerWidget,
  setLastActiveWidget,
  setAttendeesFrameRate,
  setPlayYoutubeDetails,
} = confSlice.actions;

export default confSlice.reducer;
